<app-dialog [disableClose]="true" [width]="650">
  <ng-template #bodyContent>
    <div [formGroup]="form" class="folder-payment-dialog" id="folder-payment-dialog">
      <div>
        @switch (paymentDisplayType) { @case (orderDisplayType.SingleFolderSelection) {
        <ng-container *ngTemplateOutlet="singleFolderSelection"></ng-container>
        } @case (orderDisplayType.MultipleFolderSelection) {
        <ng-container *ngTemplateOutlet="multipleFolderSelection"></ng-container>
        } @case (orderDisplayType.SingleSeatSelection) {
        <ng-container *ngTemplateOutlet="singleSeatSelection"></ng-container>
        } @case (orderDisplayType.MultipleSeatSelection) {
        <ng-container *ngTemplateOutlet="multipleSeatSelection"></ng-container>
        } @case (orderDisplayType.MultipleSubscriptionSelection) {
        <ng-container *ngTemplateOutlet="subscriptionSelection"></ng-container>
        } }
      </div>
      <ng-template #singleFolderSelection let-value="value">
        <div class="folder-payment-dialog-title">
          <h4>{{ 'orders.paymentFolderNumber' | translate }} {{ paymentFolders?.[0]?.id }}</h4>
          <div class="ms-2 folder-payment-dialog-sub-title">
            {{ 'orders.orderNumber' | translate }} {{ paymentFolders?.[0]?.orderId }}
          </div>
        </div>
      </ng-template>
      <ng-template #multipleFolderSelection>
        <div class="folder-payment-dialog-title">
          <h4>
            {{ (hasSameOrderId ? 'orders.paymentOrderNumber' :'orders.selectionPayment') |
            translate :{orderId :paymentFolders?.[0]?.orderId} }}
          </h4>
        </div>
        <div class="orders-summary-list-wrapper">
          <app-summary-list
            [items]="paymentFolders"
            [title]="'orders.payFolderList' | translate"
            [summaryLabelCallback]="hasSameOrderId ? getSummaryLabelOrderType : getSummaryLabelMultiType"
          >
          </app-summary-list>
        </div>
      </ng-template>
      <ng-template #subscriptionSelection>
        <div class="folder-payment-dialog-title">
          <h4>{{ 'orders.paymentFormula' | translate }}</h4>
          <div class="ms-2 folder-payment-dialog-sub-title">
            {{ 'orders.orderNumber' | translate }} {{ reservedSubscriptionItems?.[0]?.orderId }}
          </div>
        </div>
        <div class="orders-summary-list-wrapper">
          <app-summary-list
            [items]="reservedSubscriptionItems"
            [title]="'orders.payFolderList' | translate"
            [summaryLabelCallback]="getSummaryLabelSubscription"
          >
          </app-summary-list>
        </div>
      </ng-template>
      <ng-template #singleSeatSelection let-value="value">
        <div class="folder-payment-dialog-title">
          <h4>
            {{ 'orders.paymentPlace' | translate }}
            {{ paymentseats?.[0]?.seatInfos?.accessCode }}
            {{ paymentseats?.[0]?.seatInfos?.rank}} {{ paymentseats?.[0]?.seatInfos?.seatNumber}}
          </h4>
          <div class="ms-2 folder-payment-dialog-sub-title">
            {{ 'orders.folderNumber' | translate }} {{ paymentseats?.[0]?.orderItemId}}
          </div>
        </div>
      </ng-template>
      <ng-template #multipleSeatSelection let-value="value">
        <div class="folder-payment-dialog-title">
          <h4>{{ 'orders.paymentPlaces' | translate }}</h4>
        </div>
        <div class="orders-summary-list-wrapper">
          <app-summary-list
            [items]="paymentseats"
            [title]="'orders.payPlacesList' | translate"
            [summaryLabelCallback]="getSummaryLabelSeats"
          >
          </app-summary-list>
        </div>
      </ng-template>
      <div
        class="folder-payment-dialog-header"
        [class.mt-3]="isMultiFolderPayment || isMultiSeatPayment || isSubscriptionPayment"
      >
        <h5>{{ 'orders.customerPayer' | translate }}</h5>
        <app-customer-dropdown-list
          appendTo="body"
          [data]="customerData"
          [isLoading]="isLoading"
          [selectedId]="selectedCustomerId"
          [allowCustomerCreation]="false"
          [allowCustomerEdit]="false"
          [styleClass]="'ng-select-sm'"
          (searchTrigger)="onSearchTrigger($event)"
          (selectedChange)="onCustomerChange($event)"
          data-cy="folder-payment-payer-dropdown"
        ></app-customer-dropdown-list>
      </div>
      <div class="folder-payment-dialog-body">
        <h5>{{ 'orders.paymentMethod' | translate }}</h5>
        <app-payment-mode-form
          appendTo="body"
          [formGroup]="form"
          [modes]="paymentModes$ | async"
          [hiddenPaymentTypes]="true"
          [paymentTypes]="paymentTypes"
          [totalAmount]="totalAmount$ | async"
          [clearDefautSelection]="isSubscriptionPayment"
          (amountToReturnChange)="amountToReturn = $event"
          data-cy="orders-folder-payment-mode"
        >
          <ng-template #paymentActions></ng-template
        ></app-payment-mode-form>
        <div class="mt-5 folder-payment-dialog-body-result">
          @if (isMultiFolderPayment) {
          <span class="mx-1">{{ foldersNumber || 0 }} </span> {{ 'orders.folders' | translate }} - } @if
          (isMultiSeatPayment || isSubscriptionPayment) { <span class="mx-1">{{ seatsNumber || 0 }} </span
          >{{ 'orders.placeSingularPlural' | translate }} | }
          <span class="mx-1">{{ 'shared.payment.totalAmount' | translate }}:</span>
          <span class="total-amount ms-1">{{
            totalAmount$ | async | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr'
          }}</span>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #actionsContent>
    <button
      mat-button
      mat-dialog-close
      (click)="close()"
      data-cy="folder-payment-undo-btn"
      class="tick-btn tick-btn-secondary me-2"
    >
      {{ 'orders.paymentUndo' | translate }}
    </button>
    <button
      mat-button
      class="tick-btn tick-btn-primary me-2"
      data-cy="folder-payment-pay-btn"
      [disabled]="!form?.valid"
      (click)="pay()"
      [appHasRight]="[RightEnum.Payment]"
    >
      {{ 'shared.actions.pay' | translate }}
    </button>
  </ng-template>
</app-dialog>
